// extracted by mini-css-extract-plugin
module.exports = {"bottomNotice":"bottomNotice--1RMpN","bottomNoticeContent":"bottomNoticeContent--1cWHm","descIcon":"descIcon--1L4dr","fontBord":"fontBord--3fo5F","desc":"desc--30KXD"};